import React, { Component } from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import { GridColumn, Select, Toastr } from "arv-reactcomponents";
import { getStrippedCart } from "../../../utils";
import { Checkout } from "npmlinks-constants";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";

@inject("LoginStore", "CheckoutStore")
@observer
class QuantityView extends Component {
  static getList(item) {
    return (
      <li className="nw-common-selectlist" key={item}>
        {item}
      </li>
    );
  }
  static triggerQtyChangeGa(product, qty) {
    const { skuId } = product;
    Analytics.trackEvent({
      category: window.pageType,
      action: Event.action.MYBAG_QTY_CHANGE,
      label: `${skuId}-${qty}`,
    });
  }
  constructor() {
    super();
    this.updateQty = this.updateQty.bind(this);
  }
  get selectedQty() {
    const { product } = this.props;
    return product.qty;
  }
  get qtyDropDownRange() {
    const { product } = this.props;
    return Array.from({ length: product.sellableQty }, (v, k) => k + 1);
  }
  updateQty(newQty) {
    const { product } = this.props;
    const { qty } = product;
    if (newQty !== qty) {
      QuantityView.triggerQtyChangeGa(product, newQty);
      const { isUserLoggedIn } = this.props.LoginStore;
      const [productForRequest] = getStrippedCart([product]);
      productForRequest.qty = newQty - productForRequest.qty;
      const requestBody = Object.assign({}, Checkout.CHECKOUT_BASE_REQUEST);
      requestBody.type = Checkout.CHECKOUT_API_ACTIONS.UPDATE;
      requestBody.updateQtyCart = [productForRequest];
      this.props.CheckoutStore.updateCart(requestBody, isUserLoggedIn).then(
        () => {
          Toastr.showToastr({
            className: "nwc-toastr-list-success nw-toastr",
            message: Checkout.CHECKOUT_MESSAGES.PRODUCT.QTY_UPDATE,
            timeout: 3000,
          });
        },
      );
    }
  }
  render() {
    return (
      <GridColumn className="nwc-grid-col-sm-4">
        <div className=" nw-cartproductview-quantity">
          <div className="nw-cartproductview-qtytext">Qty:</div>
          <Select
            className="nwc-select-secondary nwc-select nw-common-select nw-cartproductview-dropdown"
            selectedValue={this.selectedQty}
            inpList={this.qtyDropDownRange}
            getSelection={this.updateQty}
            renderList={QuantityView.getList}
            compareProp="displayName"
          />
        </div>
      </GridColumn>
    );
  }
}

// QuantityView.defaultProps = {
//   className: "",
// };

QuantityView.wrappedComponent.propTypes = {
  // className: PropTypes.string,
  product: PropTypes.shape({}).isRequired,
  LoginStore: PropTypes.shape({
    isUserLoggedIn: PropTypes.bool.isRequired,
    setloginModal: PropTypes.func.isRequired,
  }).isRequired,
  CheckoutStore: PropTypes.shape({
    updateCart: PropTypes.func.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("LoginStore", "CheckoutStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: QuantityView.wrappedComponent,
  component: QuantityView,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/CartProducts/QuantityView/index.js